// extracted by mini-css-extract-plugin
export default {"root":"ErrorModal_root__JjZ6m","error":"ErrorModal_error__VdPdZ"};